import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import { imageCodes, titleCodes, textCodes, videoCodes } from "../../template_codes/madnest/contact_page_codes";

function Contact() {
    return (
        <React.Fragment>
            <div className="font-quicksand">
                <div class="navbar ">
                    <div class="navbar-start">

                    </div>
                    <div class="navbar-center lg:flex">
                        <ul class="menu menu-horizontal p-0">
                            <li className="p-2"><Link to={paths.home}>Home</Link></li>
                            <li><a href="https://themadnest.com">Shop</a></li>
                            <li className="p-2"><Link to={paths.about}>About Us</Link></li>
                            <li className="p-2"><Link to={paths.contact}>Contact</Link></li>
                        </ul>
                    </div>
                    <div className="navbar-end"></div>
                </div>
                <div className=" hero w-full h-52 pb-10 lg:h-1/3 xl:h-1/3">
                    <img src={imageCodes.bg.image} className="py-1 w-full h-48 md:h-full lg:h-full xl:h-full" />
                    <div class=" text-center text-neutral-content">
                        <div className="container place-items-end pl-20 l:pl-96 xl:pl-96">
                            <a href="https://youtu.be/DLOth-BuCNY" target="_blank"> <img src={imageCodes.moon.image} className="w-20 h-20 l:w-40 l:h-40 xl:w-40 xl:h-40"></img></a>
                        </div>
                        <h1 className="text-xl lg:text-4xl xl:text-4xl font-semibold pb-10">Contact Us</h1>

                        <ul className="list-none pb-96">
                            <li className="pb-4">
                                <p className="text-lg pt-2 lg:text-xl xl:text-xl">Facebook:</p>
                                <a href="https://www.facebook.com/madnestclothing"><p className="text-md pt-2 lg:text-xl xl:text-xl"><i>https://www.facebook.com/madnestclothing</i></p></a>
                            </li>
                            <li className="pb-4">
                                <p className="text-lg pt-2 lg:text-xl xl:text-xl">Instagram:</p>
                                <a href="https://www.instagram.com/madnest_lifestyle/"><p className="text-md pt-2 lg:text-xl xl:text-xl"><i>https://www.instagram.com/madnest_lifestyle/</i></p></a>
                            </li>
                            <li className="pb-4">
                                <p className="text-lg pt-2 lg:text-xl xl:text-xl">Phone:</p>
                                <p className="text-lg pt-2 lg:text-xl xl:text-xl"><i>+95 9 972 481604</i></p>
                            </li>
                            <li className="pb-4">
                                <p className="text-lg pt-2 lg:text-xl xl:text-xl">Location:</p>
                                <p className="text-lg pt-2 lg:text-xl xl:text-xl"><i>133 Thiri Mingalar Street 8 mile Yangon, Myanmar</i></p>
                            </li>
                        </ul>
                    </div>


                </div>
            </div>
        </React.Fragment >
    );
}

export default Contact;